// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609151004/js/" + chunkId + "." + {"44":"fcd6ed3f","225":"ac1d1bc7","481":"408a4bdb","486":"16c41660","770":"57ab95f8"}[chunkId] + ".0.9303167646044576.chunk.js";
};